export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#C9A961] py-12 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">
          <div>
            <div className="flex items-center gap-3 mb-3 sm:mb-4">
              <div className="h-10 w-10 sm:h-12 sm:w-12 rounded-full overflow-hidden bg-transparent flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/fea1a1a51237cd5b41d6d3275d2c0f20/5b38540b3234526a2f26206e289bc6d5.png"
                  alt="Chef Ziad Logo"
                  className="h-full w-full object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </div>
              <span className="font-serif text-xl sm:text-2xl font-bold text-white">
                Chef Ziad
              </span>
            </div>
            <p className="text-white/90 text-xs sm:text-sm font-light leading-relaxed">
              Luxury private chef services across London, bringing Michelin-level expertise to your special occasions.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-xs sm:text-sm tracking-wider uppercase">
              Services
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('catering')}
                  className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer text-left"
                >
                  Private Dining
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('catering')}
                  className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer text-left"
                >
                  Corporate Events
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('catering')}
                  className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer text-left"
                >
                  Weddings
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-xs sm:text-sm tracking-wider uppercase">
              Information
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer text-left"
                >
                  About Chef
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer text-left"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-3 sm:mb-4 text-xs sm:text-sm tracking-wider uppercase">
              Connect
            </h3>
            <div className="space-y-2 sm:space-y-3">
              <a
                href="https://wa.me/447843585337"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer flex items-center"
              >
                <i className="ri-phone-line mr-2"></i>
                07843 585337
              </a>
              <a
                href="mailto:yallaziad@gmail.com"
                className="text-white/90 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer flex items-center break-all"
              >
                <i className="ri-mail-line mr-2 flex-shrink-0"></i>
                yallaziad@gmail.com
              </a>
              <p className="text-white/90 text-xs sm:text-sm font-light flex items-start">
                <i className="ri-map-pin-line mr-2 mt-0.5 flex-shrink-0"></i>
                London, UK
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-white/80 text-xs sm:text-sm font-light text-center sm:text-left">
              © 2025 Chef Ziad. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/80 text-xs sm:text-sm font-light hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}